import {required,email,minLength,maxLength } from "@vuelidate/validators";
const opersonel = {
    data() {
      return { 
        opersonelData:{  
          Adsoyad:null,
          Eposta:null, 
          Dahili: null,
          Telefon:null, 
          Personeltipid:null, 
          Tckimlikno:null, 
          Birimid:null, 
          Ilid: null,
          Ilceid: null,
          Mahalle: null,
          Adres: null,
        },  
        
        resetpasswordData: { 
          Email: "",
          Token: "",
          Password: "",
          ConfirmPassword: ""
          }, 
          FormDataType:{ 
            Adsoyad:{FieldName:"Adsoyad",Field:"input",FieldTitle:"Ad Soyad",FieldType:"text"},
            Eposta:{FieldName:"Eposta",Field:"input",FieldTitle:"E-Posta"},
            Telefon:{FieldName:"Telefon",Field:"input",FieldTitle:"Telefon",FieldType : "number"},
            Dahili:{FieldName:"Dahili",Field:"input",FieldTitle:"Dahili",FieldType : "text"},
            Personeltipid:{FieldName:"Personeltipid",Field:"combobox",FieldTitle:"Kullanıcı Tipi",ComboData:{},ComboDataArray:[],Multiple:false}, 
            Tckimlikno:{FieldName:"Tckimlikno",Field:"input",FieldTitle:"T.C. Kimlik No",FieldType : "number"}, 
            Birimid:{FieldName:"Birimid",Field:"combobox",FieldTitle:"Birim",ComboData:{},ComboDataArray:[],Multiple:false}, 

            
            Ilid:{FieldName:"Ilid",Field:"combobox",FieldTitle:"İl",ComboData:{},ComboDataArray:[],Multiple:false},  
            Ilceid:{FieldName:"Ilceid",Field:"combobox",FieldTitle:"İlçe",ComboData:{},ComboDataArray:[],Multiple:false}, 
            Mahalle:{FieldName:"Mahalle",Field:"input",FieldTitle:"Mahalle",FieldType:"text"},
            Adres:{FieldName:"Adres",Field:"input",FieldTitle:"Adres",FieldType:"text"},

            
            Password:{FieldName:"Password",Field:"input",FieldTitle:"Şifre",FieldType:"password"}, 
            ConfirmPassword:{FieldName:"ConfirmPassword",Field:"input",FieldTitle:"Şifre Onay",FieldType:"password"}, 
          }  
      }  
    }, 
    validations:{ 
      FormData: {
        Adsoyad: { required },  
        Eposta: { required,email }, 
        Telefon: { required, minLength: minLength(11),maxLength: maxLength(11)  },  
        Dahili: {  }, 
        Personeltipid: {  },  
        Tckimlikno: { },  
        Birimid: {  },  
        Ilid: {  },  
        Ilceid: {  },  
        Mahalle: {  },  
        Adres: {  },  
      },
      FormDataPassword:{ 
        Password: { required,minLength: minLength(6),},  
        ConfirmPassword: { required,minLength: minLength(6), }, 
      }
  },
  created(){
    this.ActionsFilterGet({ Service: "oililce", FullData: true, Filter: "&Sadeceiller=true" }).then((res) => {
      this.FormDataType.Ilid.ComboDataArray = res.Data.map(item => ({
        id: item.Id,
        kod: item.Kod,
        label: item.Value
      }));
    });
    this.ActionsFilterGet({ Service: "okeyvalues", FullData: true, Filter: "&Tip=7" }).then((res) => {
      this.FormDataType.Personeltipid.ComboDataArray = res.Data.map(item => ({
        id: item.Id,
        label: item.Value
      }));
    });
    this.ActionsFilterGet({ Service: "obirim/gettree", FullData: true, Filter: "" }).then((res) => {
      this.FormDataType.Birimid.ComboDataArray = res.Data 
    });

   
  }
}
export default opersonel